import React from "react";
import {Radio} from "antd";
import {useController} from "react-hook-form";
import {trb} from "@utilities";

const getRadioValue = fieldValue => {
    if (typeof fieldValue === "number") return fieldValue;
    if (fieldValue === "1") return 1;
    if (fieldValue === "0") return 0;
    return fieldValue;
};

export const RadioFormField = ({
                                   title,
                                   error,
                                   options,
                                   optionsLabel,
                                   optionsValue,
                                   control,
                                   name,
                                   className = "",
                                   defaultValue,
                                   onChange,
                                   inline = false,
                                   translationGroup,
                                   ...rest
                               }) => {
    const {field, fieldState} = useController({
        control,
        name,
        ...(defaultValue !== undefined && {defaultValue})
    });
    
    return (
        <div
            className={`form-field-wrapper row  ${className}`}
        >
            {title && <label className="form-field-title radio col-12 mb-3">{title}</label>}
            <div className={`form-field-item col-12 ${error ? "has-error" : ""}`}>
                <Radio.Group
                    {...rest}
                    onBlur={field.onBlur}
                    name={field.name}
                    value={getRadioValue(field.value)}
                    className={!inline ? "hook-form-radio-group" : ""}
                    onChange={e => {
                        field.onChange(e);
                        if (onChange) {
                            onChange(e);
                        }
                    }}
                >
                    {options &&
                        options.map(item => (
                            <Radio
                                key={item[optionsValue]}
                                disabled={item.disabled}
                                value={item[optionsValue]}
                                ref={field.ref}
                            >
                                {translationGroup
                                    ? trb(translationGroup[item[optionsLabel]])
                                    : trb(item[optionsLabel])}
                            </Radio>
                        ))}
                </Radio.Group>
                {fieldState?.error?.message && (
                    <div className="form-field-error">
                        {fieldState.error.message}
                    </div>
                )}
            </div>
        </div>
    );
};
